export enum ContextMenuItems {
  SORT = 'sort',
  EXPLAIN = 'explain',
  MAXIMIZE = 'maximize',
  MANAGECOLUMNS = 'manageColumns',
}
